import { ref, readonly, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const enum LANGUAGE {
  RU = 'ru',
  EN = 'en',
}

const LANGUAGE_STORAGE_KEY = 'language';

const initialized = ref(false);

export const useLanguage = () => {
  const { locale } = useI18n();

  const getLanguage = () => {
    const languageFromLocalStorage = localStorage.getItem(LANGUAGE_STORAGE_KEY) as LANGUAGE;

    return languageFromLocalStorage;
  }

  const getSystemLanguage = () => {
    const systemLang = navigator.language || (navigator as unknown as { userLanguage: string }).userLanguage;

    console.log('System language:', systemLang);

    return systemLang.startsWith('ru') ? LANGUAGE.RU : LANGUAGE.EN;
  }

  const setLanguage = (language: LANGUAGE) => {    
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    locale.value = language;

    console.log('Language changed:', { selected: language });
  }

  const setLanguageRu = () => setLanguage(LANGUAGE.RU);
  const setLanguageEn = () => setLanguage(LANGUAGE.EN);

  const init = () => {
    if (initialized.value) return;

    const language = getLanguage();
    const systemLanguage = getSystemLanguage();

    console.log('Initial language setup:', {
      stored: language,
      system: systemLanguage
    });

    setLanguage(language || systemLanguage);
    initialized.value = true;
  }

  return {
    setLanguageRu,
    setLanguageEn,
    init,
    currentLanguage: readonly(locale),
  };
} 